import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { RestApi } from "src/app/shared/RestApi/restApi";
import { Observable } from 'rxjs';

interface scrapinginfo {
  statusMessage: any,
  error: boolean,
  data: any
}

@Injectable({
  providedIn: 'root'
})
export class ScrapingWebPagesService {
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private restAPI: RestApi
  ) { }

  retreiveScrapingWebPagesData() {
    return this.http.get<scrapinginfo>(this.restAPI.RETRIEVE_SCRAPING_WEB_PAGES, { headers: this.headers })
  }

  retreiveScrapingHistoryData() {
    return this.http.get<scrapinginfo>(this.restAPI.RETRIEVE_SCRAPING_HISTORY, { headers: this.headers })
  }
  retreiveCompareHistoryData() {
    return this.http.get<scrapinginfo>(this.restAPI.RETRIEVE_COMPARE_HISTORY, { headers: this.headers })
  }

  insertScrapingWebPages(scrapingDetails){
    return this.http.post<scrapinginfo>(this.restAPI.INSERT_SCRAPING_WEB_PAGES,JSON.stringify(scrapingDetails), { headers: this.headers })
  }

  insertScrapingHistory(scrapingDetails){
    return this.http.post<scrapinginfo>(this.restAPI.INSERT_SCRAPING_HISTORY,JSON.stringify(scrapingDetails), { headers: this.headers })
  }
  insertCompareHistory(compareHistoryDetails){
    return this.http.post<scrapinginfo>(this.restAPI.INSERT_COMPARE_HISTORY,JSON.stringify(compareHistoryDetails), { headers: this.headers })
  }
  downloadCompareDirectory(downloadObject): Observable<ArrayBuffer> {

    return this.http.post(this.restAPI.DOWNLOAD_COMPARE_REPORT_DIRECTORY,JSON.stringify(downloadObject), { responseType:'arraybuffer',headers: this.headers })
  }
  // downloadCompareDirectory(downloadObject){
  //   return this.http.post(this.restAPI.DOWNLOAD_COMPARE_REPORT_DIRECTORY,JSON.stringify(downloadObject), { headers: this.headers })
  // }
  // 
scrapeSelectedWebPage(scrapingDetails){
  return this.http.post<scrapinginfo>(this.restAPI.SCRAPE_WEB_PAGE,JSON.stringify(scrapingDetails), { headers: this.headers })
}

CompareSelectedScrapingHistory(pageId1,PageId2,dnsName){
  return this.http.post<scrapinginfo>(this.restAPI.Compare_History_PAGE+"/"+pageId1+"/"+PageId2+"/"+PageId2+"/"+dnsName, { headers: this.headers })
}
  getScrapingWebPages(){
    // this.spinner.start();
    this.retreiveScrapingWebPagesData().subscribe(res=>{
      if(res.error==true){
        // this.spinner.stop();
        this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
      }else{
        return res
      }
    })
  }

  insetScrapingWeb(scrapingDetails){
    this.spinner.start();
    this.insertScrapingWebPages(scrapingDetails).subscribe(res=>{
      if(res.error==true){
        this.spinner.stop()
        this.snackBar.open(res.statusMessage, "OK", {
          duration: 5000,
        });
      }else{
        this.spinner.stop()
        this.snackBar.open(res.statusMessage, "OK", {
          duration: 5000,
        });
      }
    })
  }

  getScrapingHistory(){
    // this.spinner.start();
    this.retreiveScrapingHistoryData().subscribe(res=>{
      if(res.error==true){
        // this.spinner.stop();
        this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
      }else{
        return res
      }
    })
  }
  getCompareHistory(){
    // this.spinner.start();
    this.retreiveCompareHistoryData().subscribe(res=>{
      if(res.error==true){
        // this.spinner.stop();
        this.snackBar.open(res.statusMessage, "OK", { duration: 5000 });
      }else{
        return res
      }
    })
  }
  
}
 